module.exports = __webpack_public_path__ + "static/media/dm.9571e249.svg";